export { default } from "./information-field";
